import { render, staticRenderFns } from "./NotificationsManagerEmpty.vue?vue&type=template&id=212a4030&scoped=true"
import script from "./NotificationsManagerEmpty.vue?vue&type=script&lang=js"
export * from "./NotificationsManagerEmpty.vue?vue&type=script&lang=js"
import style0 from "./NotificationsManagerEmpty.vue?vue&type=style&index=0&id=212a4030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a4030",
  null
  
)

export default component.exports